<template>
    <div class="col-8 mx-auto">

        <div class="d-flex flex-wrap justify-content-center mb-2">

            <!-- Attendance Card -->
            <b-button variant="outline-light" size="sm" class="action-card-btn mx-1" @click="$emit('openAttendancePreview')">
                <div class="d-flex flex-column align-items-center justify-content-center">
                    <i :class="`fas fa-calendar-check fa-2x mb-2 text-primary`"></i>
                    <span class="">Attendance Preview</span>
                </div>
            </b-button>

            <!-- Course Exit Data -->
            <b-button v-if="canViewCourseExitData" variant="outline-light" size="sm" class="action-card-btn mx-1" @click="$emit('openCourseExitData')">
                <div class="d-flex flex-column align-items-center justify-content-center">
                    <span class="mb-2">
                        <i :class="`fas fa-file-alt fa-2x text-warning`"></i>
                    </span>
                    <span class="">Course Exit Data</span>
                </div>
            </b-button>

            <!-- Errors and Warnings -->
            <b-button variant="outline-light" size="sm" class="action-card-btn mx-1" @click="$emit('openErrorsAndWarnings')">
                <div class="d-flex flex-column align-items-center justify-content-center">
                    <span class="mb-2">
                        <i :class="`fas fa-times-circle fa-2x text-danger`"></i>
                    </span>
                    <span class="">Errors and Warnings</span>
                </div>
            </b-button>            

        </div>

    </div>
</template>

<script>
import acl from "../../authorization/acl.js";

export default {
  data() {
    return {
      canViewCourseExitData: false,
    };
  },
  async mounted() {
    const isAdmin = ["Admin", "Principal"].includes(this.$store.getters.defaultInstitute.userRole);
    const isGroupAdmin = await acl.isUserGranted("groupAdmin");
    this.canViewCourseExitData = isAdmin || isGroupAdmin;
  },
};
</script>